import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import downloads from 'RuterShared/store/modules/downloads'
import consent from 'DcVueCookiebot/store/modules/consent'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
	key: 'ruteraarsrapport2020',
	storage: window.localStorage,
	//clearOn: 'user/logUserOut'
})

export default new Vuex.Store({
	plugins: [vuexPersist.plugin],
	modules: {
		downloads,
		consent
	},
	state: {
		siteName: false,
		lang: false,
		colorMode: 'dark',
		stickySideNav: false,
	},
	actions: {
		updateGlobalData({ commit }, data) {
			commit('updateGlobalData', {data: data})
		},
		updateStickySideNav({ commit }, data) {
			commit('updateStickySideNav', {data: data})
		},
		updateColorMode({ commit }, data) {
			commit('updateColorMode', {data: data})
		},
	},
	mutations: {
		updateGlobalData (state, {data}) {
			state.siteName = data.siteName
			state.lang = data.lang
		},
		updateColorMode (state, {data}) {
			state.colorMode = data.colorMode
		},
		updateStickySideNav (state, {data}) {
			state.stickySideNav = data.stickySideNav
		},
	}
})